module.exports = __webpack_public_path__ + "img/portfolio-details6.4b67e06b.png";